import { render } from "./Appraisal_Details.vue?vue&type=template&id=a24d2408&scoped=true"
import script from "./Appraisal_Details.vue?vue&type=script&lang=js"
export * from "./Appraisal_Details.vue?vue&type=script&lang=js"

import "./Appraisal_Details.vue?vue&type=style&index=0&id=a24d2408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a24d2408"]])

export default __exports__